<div class="stac-browser-page" #pageWrap>
  <!--
    The dashboard's waiting state (app-notask), from opening the page until the frame has
    loaded and shows the platform's theme (`themed`): the frame stays hidden till then.
  -->
  <div class="stac-loading" role="status" aria-live="polite" *ngIf="(loading && !stacUrl) || (stacUrl && !themed)">
    <img *ngIf="!darkMode" src="assets/images/notask.svg" alt="" />
    <img *ngIf="darkMode" src="assets/images/whitelogo.png" width="80" alt="" />
    <h3>Please wait while we load the Data Catalog</h3>
  </div>

  <div class="state-wrapper" *ngIf="hasError && !loading && !stacUrl">
    <app-error-state [message]="errorMessage"></app-error-state>
    <button mat-stroked-button type="button" class="retry-button" (click)="retry()">
      Try again
    </button>
  </div>

  <!--
    *ngIf, not [hidden]: the src must be written once and never re-pointed. See the
    stacUrl doc comment — a reload discards the user's active search.
  -->
  <!--
    SANDBOX. allow-forms added 2026-09-15 — WITHOUT IT THE SEARCH SUBMIT BUTTON DOES
    NOTHING. Not merely a console warning: Blink's sandbox check sits in
    HTMLFormElement::PrepareForSubmission and returns BEFORE the `submit` event is
    dispatched, so STAC Browser's own @submit.stop.prevent="onSubmit" handler
    (eestacui SearchFilter.vue:2) never runs and no search is ever issued. The symptom
    is a silent no-op plus "Blocked form submission to '' because the form's frame is
    sandboxed and the 'allow-forms' permission is not set."

    Measured with Playwright, three iframes, identical markup: the submit listener
    fired TRUE with no sandbox, FALSE under `allow-scripts allow-same-origin`, and TRUE
    again once allow-forms was added.

    Security note: this frame already carries allow-scripts AND allow-same-origin and is
    same-origin with the host page by design (the bridge reads into it), so the sandbox
    here is hygiene rather than a trust boundary — the frame can already reach
    parent.document. allow-forms adds no meaningful capability beyond that. (The
    platform's only other sandboxed iframe, payment.component.html:100, grants a wider
    set still — but it is commented out, so it is not a live precedent.)

    Deliberately still ABSENT: allow-top-navigation (the frame must never navigate the
    platform away) and allow-modals (nothing in the app calls alert/confirm/print — its
    dialogs are Vue components).
  -->
  <div class="session-error" role="alert" *ngIf="hasError && stacUrl">
    <span>{{ errorMessage }}</span>
    <button mat-stroked-button type="button" (click)="retry()" [disabled]="loading">Retry</button>
  </div>
  <iframe
    *ngIf="stacUrl"
    #stacFrame
    class="stac-frame"
    [class.themed]="themed"
    [src]="stacUrl | safe"
    title="Eartheye data browser"
    referrerpolicy="no-referrer"
    sandbox="allow-scripts allow-same-origin allow-downloads allow-popups allow-forms"
    (load)="onFrameLoad()"
  ></iframe>
</div>
